<template>
  <section class="section -center">
    <h2 class="section__title" v-reveal>{{ title }}</h2>
    <p class="section__text -lg" v-reveal="{ delay: 200 }">{{ text }}</p>

    <div class="comity">
      <div class="comity__tabs" v-reveal>
        <button
          class="comity__tabs-tab"
          :class="{ '-active': tab === key }"
          v-for="(region, key) in tabs"
          :key="key"
          @click="tab = key"
        >
          {{ region.label }}
        </button>
      </div>
      <transition name="fade" mode="out-in">
        <div class="comity__cards" :key="tab">
          <div
            class="comity__card"
            v-reveal="{ delay: key * 75 }"
            v-for="(card, key) in currentTab"
            :key="key"
            @click="openCard(key)"
            :class="{ '-clickable': card.content, '-active': openedCard === key }"
          >
            <div class="comity__card-row">
              <h4 class="comity__card-name">
                {{ card.name }}
              </h4>
              <div v-if="card.content">
                <transition name="fade-fast" mode="out-in">
                  <icon id="minus" v-if="openedCard === key" key="-" />
                  <icon id="plus" v-else key="+" />
                </transition>
              </div>
            </div>

            <p class="comity__card-title">
              {{ card.title }}{{ card.company ? `, ${card.company}` : '' }}
            </p>
            <DropDown :is-open="openedCard === key">
              <p>{{ card.content }}</p>
            </DropDown>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionComite',
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'COMITÉS',
    },
    text: {
      type: String,
      default: 'Lorem ipsum',
    },
  },
  data() {
    return {
      tab: 0,
      openedCard: null,
    }
  },
  computed: {
    currentTab() {
      return this.tabs[this.tab].cards
    },
    tabs() {
      return this.groups.map((group) => {
        return {
          label: group.name,
          cards: group.members.map((id) => {
            const member = this.$beet.members[Number(id)]
            return {
              name: member.name,
              title: member.jobTitle,
              content: member.description,
              company: member.company,
            }
          }),
        }
      })
    },
  },
  methods: {
    openCard(key) {
      if (this.openedCard === key) this.openedCard = null
      else this.openedCard = key
    },
  },
}
</script>
